import useCityNameInFormHeadlineForSEM from '@/hooks/useCityNameInFormHeadlineForSEM'
import useContentfulSearchFormHeadlines from '@/hooks/useContentfulSearchFormHeadlines'
import useSEMSearchHeadline from '@/hooks/useSEMSearchHeadline'
import type { LOCATION_SEARCH_TYPE } from '@/types'
import { PRIMARY_HEADING_FALLBACK } from './constants'

export default function useHotelFormHeadline(location: LOCATION_SEARCH_TYPE | undefined) {
  const searchForm = useContentfulSearchFormHeadlines('searchForm')
  const prePopHeadline = useCityNameInFormHeadlineForSEM(location)
  const SEMHeadline = useSEMSearchHeadline()

  return prePopHeadline ?? SEMHeadline ?? (searchForm?.headline || PRIMARY_HEADING_FALLBACK)
}
